<div class="w-100 d-flex flex-column" style="height: 100vh;">
  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
    <div class="container-fluid">
      <div class="row w-100 align-items-start gx-0">
        <!-- Logo -->
        <div class="col-md-3 col-lg-2 d-flex justify-content-center align-items-center pt-4">
          <a class="navbar-brand" href="chat" (click)="handleLogoClick()">
            <img 
              [src]="logoUrl" 
              alt="SWIRL logo"
              class="logo-img"
              [class.chat-logo-img]="useChatLogoStyle"
            />
          </a>
        </div>

        <!-- Icon Menus Column -->
        <div class="col-auto d-flex align-items-center justify-content-end pt-4 pe-4 ms-auto">
          <chat-info-menu class="me-2"></chat-info-menu>
          <chat-profile-box></chat-profile-box>
        </div>
      </div>
    </div>
  </nav>

  <!-- Chat Toggle + Export as PDF row -->
  <div class="container-fluid mt-3 pe-4 toggle-export-row">
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">

        <!-- Chat History Toggle -->
        <button class="history-toggle-btn d-flex align-items-center"
                *ngIf="chatHistoryEnabled"
                (click)="toggleHistory()"
                aria-label="Toggle Chat History"
                title="Toggle Chat History">
          <ng-container *ngIf="historySidenav">
            <img [src]="historySidenav.opened 
                        ? 'assets/images/icon_hidehistory.png' 
                        : 'assets/images/icon_viewhistory.png'"
                  alt="Toggle Chat History">
            <span class="ms-2">
              {{ historySidenav.opened ? 'HIDE HISTORY' : 'SHOW HISTORY' }}
            </span>
          </ng-container>
        </button>

        <!-- Export as PDF -->
        <button (click)="onExportPdf()" 
                class="export-link" 
                *ngIf="isConversationStarted">
          Export as PDF
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <main class="container-fluid flex-grow-1 d-flex overflow-hidden mt-2">
    <mat-sidenav-container class="flex-grow-1 mat-elevation-z0"
                          [hasBackdrop]="false">

      <!-- Chat History Drawer -->
      <mat-sidenav #history
             mode="over"
             position="start"
             [disableClose]="true"
             class="chat-history-sidenav">
        <app-chat-history></app-chat-history>
      </mat-sidenav>

      <!-- Chat Content -->
      <mat-sidenav-content class="d-flex flex-column overflow-hidden">
        <div class="container-fluid d-flex flex-column flex-grow-1 overflow-auto">
          <div class="row flex-grow-1">
            <div class="col-md-9 col-lg-10 offset-md-3 offset-lg-2 d-flex flex-column flex-grow-1 chat-content-wrapper export-chat">

              <!-- PDF export header (only) -->
              <div class="print-header" aria-hidden="true">
                <img class="print-logo" src="/api/swirl/sapi/branding/?target=chat" alt="SWIRL logo" />
              </div>

              <!-- Active Chat Boxes -->
              <div *ngIf="isConversationStarted" class="chat-box-wrapper">
                <app-chat class="chat-box" [messages]="messages"></app-chat>
              </div>

              <!-- Centered Chat Box for New Sessions -->
              <div *ngIf="!isConversationStarted && isAIProviderExists"
                   class="d-flex flex-grow-1 justify-content-center align-items-center">
                <div class="chat-box-wrapper">
                  <app-chat-box class="chat-box" [autoFocus]="true"></app-chat-box>
                </div>
              </div>

              <!-- No AIProviders error -->
              <div *ngIf="isAIProviderLoaded && !isAIProviderExists"
                   class="error-text text-center" role="alert">
                There are no AIProviders configured.
              </div>

            </div>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </main>

  <!-- Footer -->
  <footer class="bg-light border-top shadow-sm py-2"
          *ngIf="isConversationStarted && isAIProviderExists; else noFooter">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-9 col-lg-10 offset-md-3 offset-lg-2">
          <div class="chat-box-wrapper">
            <app-chat-box class="chat-box" [autoFocus]="true"></app-chat-box>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <ng-template #noFooter></ng-template>
</div>
